import script from "./Model.vue?vue&type=script&setup=true&lang=js"
export * from "./Model.vue?vue&type=script&setup=true&lang=js"

import "./Model.vue?vue&type=style&index=0&id=3d837440&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d837440"]])

export default __exports__